module.exports = __webpack_public_path__ + "static/ko-74ae14f504591a05eb4d241d177aa25f.png";